import type { BenefitItem } from 'components/home/Benefits';

export const benefitsHeading =
  'DS-01® benefits you can feel in as little as 7 days.°';

export const benefitsItems: BenefitItem[] = [
  {
    icon: 'bloating',
    timeframe: '7 Days',
    benefit: 'Relief from bloating**°',
  },
  {
    icon: 'regularity-clock',
    timeframe: '2 Weeks',
    benefit: 'Supports healthy regularity°††',
  },
  {
    icon: 'skin-health',
    timeframe: '4 Weeks',
    benefit: 'Smooths skin aging°††',
  },
  {
    icon: 'whole-body-support',
    timeframe: '3 Months',
    benefit: 'Promotes whole-body health°',
  },
];
